import React, { useState } from "react";

const Marimencoba = () => {
	const [show1,setShow1]= useState(false)
	const [show2,setShow2]= useState(false)
	const [show3,setShow3]= useState(false)
	const [show4,setShow4]= useState(false)
	const [show5,setShow5]= useState(false)
	const [show6,setShow6]= useState(false)
	const [show7,setShow7]= useState(false)
	const [show8,setShow8]= useState(false)
	const [show9,setShow9]= useState(false)
	const [show10,setShow10]= useState(false)

	const [styleno1, setStyleno1] = useState({ width: "40px" });
	const [styleno2, setStyleno2] = useState({ width: "40px" });
	const [styleno3, setStyleno3] = useState({ width: "40px" });
	const [styleno4, setStyleno4] = useState({ width: "40px" });
	const [styleno5, setStyleno5] = useState({ width: "40px" });
	const [styleno6, setStyleno6] = useState({ width: "40px" });
	const [styleno7, setStyleno7] = useState({ width: "40px" });

	// no2
	const [styleno2a, setStyleno2a] = useState({ width: "40px" });
	const [styleno2b, setStyleno2b] = useState({ width: "40px" });
	const [styleno2c, setStyleno2c] = useState({ width: "40px" });
	const [styleno2d, setStyleno2d] = useState({ width: "40px" });
	const [styleno2e, setStyleno2e] = useState({ width: "40px" });
	const [styleno2f, setStyleno2f] = useState({ width: "40px" });
	const [styleno2g, setStyleno2g] = useState({ width: "40px" });
	const [styleno2h, setStyleno2h] = useState({ width: "40px" });
	const [styleno2i, setStyleno2i] = useState({ width: "40px" });
	const [styleno2j, setStyleno2j] = useState({ width: "40px" });

	// no3
	const [styleno3a, setStyleno3a] = useState({ width: "40px" });
	const [styleno3b, setStyleno3b] = useState({ width: "40px" });
	const [styleno3c, setStyleno3c] = useState({ width: "40px" });
	const [styleno3d, setStyleno3d] = useState({ width: "40px" });
	const [styleno3e, setStyleno3e] = useState({ width: "40px" });
	const [styleno3f, setStyleno3f] = useState({ width: "40px" });
	const [styleno3g, setStyleno3g] = useState({ width: "40px" });
	const [styleno3h, setStyleno3h] = useState({ width: "40px" });
	const [styleno3i, setStyleno3i] = useState({ width: "40px" });
	const [styleno3j, setStyleno3j] = useState({ width: "40px" });
	// no4
	const [styleno4a, setStyleno4a] = useState({ width: "40px" });
	const [styleno4b, setStyleno4b] = useState({ width: "40px" });
	const [styleno4c, setStyleno4c] = useState({ width: "40px" });
	const [styleno4d, setStyleno4d] = useState({ width: "40px" });
	const [styleno4e, setStyleno4e] = useState({ width: "40px" });
	const [styleno4f, setStyleno4f] = useState({ width: "40px" });
	const [styleno4g, setStyleno4g] = useState({ width: "40px" });
	const [styleno4h, setStyleno4h] = useState({ width: "40px" });
	const [styleno4i, setStyleno4i] = useState({ width: "40px" });
	const [styleno4j, setStyleno4j] = useState({ width: "40px" });
	// no5
	const [styleno5a, setStyleno5a] = useState({ width: "40px" });
	const [styleno5b, setStyleno5b] = useState({ width: "40px" });
	const [styleno5c, setStyleno5c] = useState({ width: "40px" });
	const [styleno5d, setStyleno5d] = useState({ width: "40px" });
	const [styleno5e, setStyleno5e] = useState({ width: "40px" });
	const [styleno5f, setStyleno5f] = useState({ width: "40px" });
	const [styleno5g, setStyleno5g] = useState({ width: "40px" });
	const [styleno5h, setStyleno5h] = useState({ width: "40px" });
	const [styleno5i, setStyleno5i] = useState({ width: "40px" });
	const [styleno5j, setStyleno5j] = useState({ width: "40px" });

	const handleNo1a = (no1a) => {
		const jwb = no1a.target.value;
		jwb === "1"
			? setStyleno1({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno1({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno1({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo1b = (no1b) => {
		const jwb = no1b.target.value;
		jwb === "1"
			? setStyleno2({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno2({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo1c = (no1c) => {
		const jwb = no1c.target.value;
		jwb === "120"
			? setStyleno3({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno3({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno3({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo1d = (no1d) => {
		const jwb = no1d.target.value;
		jwb === "1"
			? setStyleno4({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno4({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno4({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo1e = (no1e) => {
		const jwb = no1e.target.value;
		jwb === "30"
			? setStyleno5({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno5({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno5({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo1f = (no1f) => {
		const jwb = no1f.target.value;
		jwb === "1"
			? setStyleno6({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno6({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno6({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo1g = (no1g) => {
		const jwb = no1g.target.value;
		jwb === "50"
			? setStyleno7({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno7({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno7({
					width: "50px",
					border: "6px solid red",
			  });
	};

	// no2

	const handleNo2a = (no2a) => {
		const jwb = no2a.target.value;
		jwb === "1"
			? setStyleno2a({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2a({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno2a({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo2b = (no2b) => {
		const jwb = no2b.target.value;
		jwb === "1"
			? setStyleno2b({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2b({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno2b({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo2c = (no2c) => {
		const jwb = no2c.target.value;
		jwb === "18"
			? setStyleno2c({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2c({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno2c({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo2d = (no2d) => {
		const jwb = no2d.target.value;
		jwb === "1"
			? setStyleno2d({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2d({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno2d({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo2e = (no2e) => {
		const jwb = no2e.target.value;
		jwb === "2"
			? setStyleno2e({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2e({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno2e({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo2f = (no2f) => {
		const jwb = no2f.target.value;
		jwb === "26"
			? setStyleno2f({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2f({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno2f({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo2g = (no2g) => {
		const jwb = no2g.target.value;
		jwb === "1"
			? setStyleno2g({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2g({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno2g({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo2h = (no2h) => {
		const jwb = no2h.target.value;
		jwb === "0"
			? setStyleno2h({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2h({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno2h({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo2i = (no2i) => {
		const jwb = no2i.target.value;
		jwb=== "1"
			? setStyleno2i({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2i({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno2i({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo2j = (no2j) => {
		const jwb = no2j.target.value;
		jwb === "0"
			? setStyleno2j({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2j({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno2j({
					width: "50px",
					border: "6px solid red",
			  });
	};

	//no3

	const handleNo3a = (no3a) => {
		const jwb = no3a.target.value;
		jwb === "1"
			? setStyleno3a({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno3a({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno3a({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo3b = (no3b) => {
		const jwb = no3b.target.value;
		jwb === "1"
			? setStyleno3b({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno3b({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno3b({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo3c = (no3c) => {
		const jwb = no3c.target.value;
		jwb === "500"
			? setStyleno3c({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno3c({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno3c({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo3d = (no3d) => {
		const jwb = no3d.target.value;
		jwb === "2"
			? setStyleno3d({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno3d({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno3d({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo3e = (no3e) => {
		const jwb = no3e.target.value;
		jwb === "1"
			? setStyleno3e({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno3e({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno3e({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo3f = (no3f) => {
		const jwb = no3f.target.value;
		jwb === "400"
			? setStyleno3f({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno3f({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno3f({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo3g = (no3g) => {
		const jwb = no3g.target.value;
		jwb=== "1"
			? setStyleno3g({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno3g({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno3g({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo3h = (no3h) => {
		const jwb = no3h.target.value;
		jwb === "0"
			? setStyleno3h({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno3h({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno3h({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo3i = (no3i) => {
		const jwb = no3i.target.value;
		jwb === "1"
			? setStyleno3i({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno3i({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno3i({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo3j = (no3j) => {
		const jwb = no3j.target.value;
		jwb === "0"
			? setStyleno3j({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno3j({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno3j({
					width: "50px",
					border: "6px solid red",
			  });
	};

	//no4

	const handleNo4a = (no4a) => {
		const jwb = no4a.target.value;
		jwb === "3"
			? setStyleno4a({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno4a({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno4a({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo4b = (no4b) => {
		const jwb = no4b.target.value;
		jwb === "2"
			? setStyleno4b({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno4b({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno4b({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo4c = (no4c) => {
		const jwb = no4c.target.value;
		jwb === "9"
			? setStyleno4c({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno4c({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno4c({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo4d = (no4d) => {
		const jwb = no4d.target.value;
		jwb === "2"
			? setStyleno4d({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno4d({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno4d({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo4e = (no4e) => {
		const jwb = no4e.target.value;
		jwb === "4"
			? setStyleno4e({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno4e({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno4e({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo4f = (no4f) => {
		const jwb = no4f.target.value;
		jwb === "9"
			? setStyleno4f({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno4f({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno4f({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo4g = (no4g) => {
		const jwb = no4g.target.value;
		jwb=== "1"
			? setStyleno4g({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno4g({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno4g({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo4h = (no4h) => {
		const jwb = no4h.target.value;
		jwb === "0"
			? setStyleno4h({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno4h({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno4h({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo4i = (no4i) => {
		const jwb = no4i.target.value;
		jwb=== "1"
			? setStyleno4i({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno4i({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno4i({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleNo4j = (no4j) => {
		const jwb = no4j.target.value;
		jwb === "0"
			? setStyleno4j({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno4j({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno4j({
					width: "50px",
					border: "6px solid red",
			  });
	};

	//no5

	const handleNo5a = (no5a) => {
		const jwb = no5a.target.value;
		if (jwb === "2") {
			setStyleno5a({
				width: "50px",
				border: "6px solid #1aff66",
			});
			setShow1(true);
		} else if (jwb === "") {
			setStyleno5a({
				width: "50px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno5a({
				width: "50px",
				border: "6px solid red",
			});
		}
	};
	const handleNo5b = (no5b) => {
		const jwb = no5b.target.value;
		if (jwb === "1") {
			setStyleno5b({
				width: "50px",
				border: "6px solid #1aff66",
			});
			setShow2(true);
		} else if (jwb === "") {
			setStyleno5b({
				width: "50px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno5b({
				width: "50px",
				border: "6px solid red",
			});
		}
	};
	const handleNo5c = (no5c) => {
		const jwb = no5c.target.value;
		if (jwb === "100") {
			setStyleno5c({
				width: "50px",
				border: "6px solid #1aff66",
			});
			setShow3(true);
		} else if (jwb === "") {
			setStyleno5c({
				width: "50px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno5c({
				width: "50px",
				border: "6px solid red",
			});
		}
	};
	const handleNo5d = (no5d) => {
		const jwb = no5d.target.value;
		if (jwb === "5") {
			setStyleno5d({
				width: "50px",
				border: "6px solid #1aff66",
			});
			setShow4(true);
		} else if (jwb === "") {
			setStyleno5d({
				width: "50px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno5d({
				width: "50px",
				border: "6px solid red",
			});
		}
	};
	const handleNo5e = (no5e) => {
		const jwb = no5e.target.value;
		if (jwb === "2") {
			setStyleno5e({
				width: "50px",
				border: "6px solid #1aff66",
			});
			setShow5(true);
		} else if (jwb === "") {
			setStyleno5e({
				width: "50px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno5e({
				width: "50px",
				border: "6px solid red",
			});
		}
	};
	const handleNo5f = (no5f) => {
		const jwb = no5f.target.value;
		if (jwb === "50") {
			setStyleno5f({
				width: "50px",
				border: "6px solid #1aff66",
			});
			setShow6(true);
		} else if (jwb === "") {
			setStyleno5f({
				width: "50px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno5f({
				width: "50px",
				border: "6px solid red",
			});
		}
	};
	const handleNo5g = (no5g) => {
		const jwb = no5g.target.value;
	if(	jwb === "1"){
			setStyleno5g({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			  setShow7(true)
	}else if ( jwb === ""){
			 setStyleno5g({
					width: "50px",
					border: "6px solid yellow",
			  })}
			  else{
			 setStyleno5g({
					width: "50px",
					border: "6px solid red",
			  })}
	};
	const handleNo5h = (no5h) => {
		const jwb = no5h.target.value;
		if(	jwb === "0"){
				setStyleno5h({
						width: "50px",
						border: "6px solid #1aff66",
				  })
				  setShow8(true)
		}else if ( jwb === ""){
				 setStyleno5h({
						width: "50px",
						border: "6px solid yellow",
				  })}
				  else{
				 setStyleno5h({
						width: "50px",
						border: "6px solid red",
				  })}
	};
	const handleNo5i = (no5i) => {
		const jwb = no5i.target.value;
		if(	jwb === "1"){
			setStyleno5i({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			  setShow9(true)
	}else if ( jwb === ""){
			 setStyleno5i({
					width: "50px",
					border: "6px solid yellow",
			  })}
			  else{
			 setStyleno5i({
					width: "50px",
					border: "6px solid red",
			  })}
	
	};
	const handleNo5j = (no5j) => {
		const jwb = no5j.target.value;
		if(	jwb === "0"){
			setStyleno5j({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			  setShow10(true)
	}else if ( jwb === ""){
			 setStyleno5j({
					width: "50px",
					border: "6px solid yellow",
			  })}
			  else{
			 setStyleno5j({
					width: "50px",
					border: "6px solid red",
			  })}
	};

	return (
		<div className="container">
			<div className="row">
					<div className="col">
						<div
							className="card mt-2 mb-2 border-success"
							style={{ borderRadius: "20px" }}
						>
							<div
								style={{ backgroundColor: "#40bf80", borderRadius: "20px" }}
								className="card-header"
							>
								<h6 className="text-white text-center">Petunjuk Pengerjaan</h6>
							</div>
							<div className="card-body">
								<ol>
									<li>Perhatikan dengan teliti !</li>
									<li>Kalian harus mengisi form yang kosong</li>
									<li>
										Apabila benar maka border form akan berwarna hijau, Apabila salah maka border form akan berwarna merah
									</li>
									<li>Kalian harus mengisi semua agar dapat memahami materi ini!</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
		

			<div className="card">
				<div
					className="card-header text-white"
					style={{ backgroundColor: "#2d8659" }}
				>
					<p>
						Pabrik roti memproduksi 120 kaleng roti setiap hari. Roti terdiri
						atas dua jenis, yaitu asin dan manis. Setiap hari roti asin
						diproduksi paling sedikit 30 kaleng dan roti manis 50 kaleng. Model
						matematika dari soal ini, jika dimisalkan roti asin sebanyak x
						kaleng dan roti manis sebanyak y kaleng adalah ….
					</p>
				</div>
				<div className="card-body" style={{backgroundColor:'#ecf9f2'}}>
					<p>
						<input
							type="text"
							style={styleno1}
							onChange={handleNo1a}
							
						/> &nbsp;x
						+
						<input
							type="text"
							style={styleno2}
							onChange={handleNo1b}
							
						/>&nbsp;y
						≤
						<input
							type="text"
							style={styleno3}
							onChange={handleNo1c}
							
						/>{" "}
						(1){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno4}
							onChange={handleNo1d}
							
						/>x
						≥{" "}
						<input
							type="text"
							style={styleno5}
							onChange={handleNo1e}
							
						/>{" "}
						(2){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno6}
							onChange={handleNo1f}
							
						/>y
						≥{" "}
						<input
							type="text"
							style={styleno7}
							onChange={handleNo1g}
							
						/>{" "}
						(3){" "}
					</p>
				</div>
			</div>
			<div className="card mt-3">
				<div
					className="card-header text-white"
					style={{ backgroundColor: "#2d8659" }}
				>
					<p>
						Aldi seorang wiraswasta membuat dua macam ember yang setiap harinya
						menghasilkan tidak lebih dari 18 buah. Harga bahan untuk jenis
						pertama Rp5.000,00 dan untuk ember jenis kedua Rp10.000,00. Ia tidak
						akan berberlanja lebih dari Rp130.000,00 setiap harinya. Jika jenis
						ember pertama dibuat sebanyak x buah dan jenis kedua sebanyak y
						buah, maka sistem pertidaksamaannya adalah…
					</p>
				</div>
				<div className="card-body" style={{backgroundColor:'#ecf9f2'}}>
					<p>
						<input
							type="text"
							style={styleno2a}
							onChange={handleNo2a}
							
						/>
						+&nbsp; x
						<input
							type="text"
							style={styleno2b}
							onChange={handleNo2b}
							
						/>&nbsp; y
						≤{" "}
						<input
							type="text"
							style={styleno2c}
							onChange={handleNo2c}
							
						/>{" "}
						(1){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno2d}
							onChange={handleNo2d}
							
						/>&nbsp; x
						+{" "}
						<input
							type="text"
							style={styleno2e}
							onChange={handleNo2e}
							
						/>&nbsp; y
						≤{" "}
						<input
							type="text"
							style={styleno2f}
							onChange={handleNo2f}
							
						/>{" "}
						(2){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno2g}
							onChange={handleNo2g}
							
						/>x
						≥{" "}
						<input
							type="text"
							style={styleno2h}
							onChange={handleNo2h}
							
						/>
						(3){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno2i}
							onChange={handleNo2i}
							
						/>y
						≥{" "}
						<input
							type="text"
							style={styleno2j}
							onChange={handleNo2j}
							
						/>{" "}
						(4){" "}
					</p>
				</div>
			</div>

			<div className="card mt-3">
				<div
					className="card-header text-white"
					style={{ backgroundColor: "#2d8659" }}
				>
					<p>
						Harga 1kg pupuk jenis A Rp40.000,00 sedangkan pupuk jenis B
						Rp20.000,00. Jika petani hanya mempunyai modal Rp8.000.000,00 dan
						gudang hanya mampu menampung 500kg pupuk. Misal pupuk A sebanyak x
						dan pupuk B sebanyak y, maka model matematika dari permasalahan
						tersebut adalah…
					</p>
				</div>
				<div className="card-body" style={{backgroundColor:'#ecf9f2'}}>
					<p>
						<input
							type="text"
							style={styleno3a}
							onChange={handleNo3a}
							
						/>&nbsp; x
						+{" "}
						<input
							type="text"
							style={styleno3b}
							onChange={handleNo3b}
							
						/>&nbsp; y
						≤{" "}
						<input
							type="text"
							style={styleno3c}
							onChange={handleNo3c}
							
						/>{" "}
						(1){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno3d}
							onChange={handleNo3d}
							
						/>&nbsp; x
						+{" "}
						<input
							type="text"
							style={styleno3e}
							onChange={handleNo3e}
							
						/>&nbsp; y
						≤{" "}
						<input
							type="text"
							style={styleno3f}
							onChange={handleNo3f}
							
						/>{" "}
						(2){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno3g}
							onChange={handleNo3g}
							
						/> x
						≥{" "}
						<input
							type="text"
							style={styleno3h}
							onChange={handleNo3h}
							
						/>{" "}
						(3){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno3i}
							onChange={handleNo3i}
							
						/> y
						≥{" "}
						<input
							type="text"
							style={styleno3j}
							onChange={handleNo3j}
							
						/>{" "}
						(4){" "}
					</p>
				</div>
			</div>

			<div className="card mt-3">
				<div
					className="card-header text-white"
					style={{ backgroundColor: "#2d8659" }}
				>
					<p>
						Untuk membuat barang A diperlukan waktu 6 jam kerja mesin 1 dan 4
						jam kerja mesin 2, sedangkan untuk barang B diperkukan waktu 4 jam
						kerja mesin 1 dan 8 jam kerja mesin 2. Setiap hari kedua mesin
						tersebut bekerja tidak lebih dari 18 jam. Jika setiap hari dapat
						dihasilkan x barang A dan y barang B, maka model matematikanya
						adalah …
					</p>
				</div>
				<div className="card-body" style={{backgroundColor:'#ecf9f2'}}>
					<p>
						<input
							type="text"
							style={styleno4a}
							onChange={handleNo4a}
							
						/>&nbsp; x
						+{" "}
						<input
							type="text"
							style={styleno4b}
							onChange={handleNo4b}
							
						/>&nbsp; y
						≤{" "}
						<input
							type="text"
							style={styleno4c}
							onChange={handleNo4c}
							
						/>{" "}
						(1){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno4d}
							onChange={handleNo4d}
							
						/> x
						+{" "}
						<input
							type="text"
							style={styleno4e}
							onChange={handleNo4e}
							
						/> y
						≤{" "}
						<input
							type="text"
							style={styleno4f}
							onChange={handleNo4f}
							
						/>{" "}
						(2){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno4g}
							onChange={handleNo4g}
							
						/> x
						≥{" "}
						<input
							type="text"
							style={styleno4h}
							onChange={handleNo4h}
							
						/>{" "}
						(3){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno4i}
							onChange={handleNo4i}
							
						/> y
						≥{" "}
						<input
							type="text"
							style={styleno4j}
							onChange={handleNo4j}
							
						/>{" "}
						(4){" "}
					</p>
				</div>
			</div>

			<div className="card mt-3 mb-2">
				<div
					className="card-header text-white"
					style={{ backgroundColor: "#2d8659" }}
				>
					<p>
						Seorang pengusaha mebel akan memproduksi meja dan kursi yang
						menggunakan bahan dari papan-papan katu dengan ukuran tertentu. Satu
						meja memerlukan bahan 10 potong papan dan satu kursi memerlukan 5
						potong papan. Papan yang tersedia adalah 500 potong. Biaya pembuatan
						satu meja Rp1.000.000,00 dan biaya pembuatan satu kursi
						Rp400.000,00. Anggaran yang tersedia adalah Rp10.000.000,00. Dengan memisalkan x banyaknya meja yang dibuat dan y banyaknya kursi yang dibuat. Model
						matematika dari persoalan tersebut adalah ...
					</p>
				</div>
				<div className="card-body" style={{backgroundColor:'#ecf9f2'}}>
					<p>
						<input
							type="text"
							style={styleno5a}
							onChange={handleNo5a}
							
						/>&nbsp; x
						+{" "}
						<input
							type="text"
							style={styleno5b}
							onChange={handleNo5b}
							
						/>&nbsp; y
						≤{" "}
						<input
							type="text"
							style={styleno5c}
							onChange={handleNo5c}
							
						/>{" "}
						(1){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno5d}
							onChange={handleNo5d}
							
						/>&nbsp; x
						+{" "}
						<input
							type="text"
							style={styleno5e}
							onChange={handleNo5e}
							
						/>&nbsp; y
						≤{" "}
						<input
							type="text"
							style={styleno5f}
							onChange={handleNo5f}
							
						/>{" "}
						(2){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno5g}
							onChange={handleNo5g}
							
						/> x
						≥{" "}
						<input
							type="text"
							style={styleno5h}
							onChange={handleNo5h}
							
						/>{" "}
						(3){" "}
					</p>
					<p>
						<input
							type="text"
							style={styleno5i}
							onChange={handleNo5i}
							
						/> y
						≥{" "}
						<input
							type="text"
							style={styleno5j}
							onChange={handleNo5j}
							
						/>{" "}
						(4){" "}
					</p>
				</div>
			</div>
			{show1&&show2&&show3&&show4&&show5&&show6&&show7&&show8&&show9&&show10?
			<>
			<div className="text-center alert alert-success mt-3 mb-2">Yeay kamu telah mencoba semua, Selanjutnya tutup halaman ini lalu ke kuis!!!</div>
			</>
			:null}
		</div>
	);
};

export default Marimencoba;
